import { ref, watch } from 'vue';
import { initialDark, persistTheme } from '../theme';

// Single source of truth for dark mode across all Vue modules.
// Re-exported by inventory-vue/composables/useDarkMode.ts and
// window-stickers-vue/composables/useDarkMode.ts so the shared module
// instance is reached via either path within a single bundle —
// preventing dual singletons when components are imported across modules.
const isDark = ref(initialDark());

watch(isDark, (val) => {
  persistTheme(val);
  // Sync legacy key used by CompetitorsModal
  try { localStorage.setItem('competitorsDarkMode', String(val)); } catch {}
});

export function useDarkMode() {
  const toggle = () => { isDark.value = !isDark.value; };
  return { isDark, toggle };
}
